import * as actions from 'redux/actions/domainsData.actions'
import * as keywordGrossingActions from 'redux/actions/keywordGrossing.actions'
import * as keywordDiscoveryActions from 'redux/actions/keywordDiscovery.actions'
import * as keywordSavingsOverviewActions from 'redux/actions/keywordSavingsOverview.actions'
import updateKeywords from './updateKeywords'
import { setCompetitorsColor } from './updateCompetitors'

const updateDomain = (existingDomain, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomainTagsSuccess.type:
      return {
        ...existingDomain,
        tags: payload.tags
      }

    case actions.loadKeywordsSuccess.type:
    case actions.loadKeywordsResultsSuccess.type:
    case actions.loadKeywordsChangesSuccess.type:
    case actions.loadKeywordsCompetitorsResultsSuccess.type:
    case actions.loadKeywordsCompetitorsChangesSuccess.type: {
      const keywords = updateKeywords(existingDomain.keywords || [], payload.keywords, type)
      return {
        ...existingDomain,
        keywords
      }
    }
    case actions.loadCompetitorsSuccess.type:
      return {
        ...existingDomain,
        competitors: setCompetitorsColor(payload.competitors)
      }
    case keywordGrossingActions.getDomainKeywordGrossingSuccess.type:
      return {
        ...existingDomain,
        grossing: payload.grossing
      }
    case keywordDiscoveryActions.getDomainKeywordDiscoverySuccess.type:
      return {
        ...existingDomain,
        discovery: payload.discovery
      }
    case keywordSavingsOverviewActions.getDomainKeywordSavingsOverviewSuccess.type:
      return {
        ...existingDomain,
        savingsOverview: payload.savingsOverview
      }
    case actions.loadDomainSuccess.type:
      return {
        ...existingDomain,
        data: payload.data
      }
    default:
      return existingDomain
  }
}

export default updateDomain
